/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SurfaceRulesSection
 */
export interface SurfaceRulesSection {
    /**
     * Section heading, e.g. "3. Eligibility". Omit for the lead disclaimer.
     * @type {string}
     * @memberof SurfaceRulesSection
     */
    heading?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof SurfaceRulesSection
     */
    paragraphs?: Array<string>;
}

/**
 * Check if a given object implements the SurfaceRulesSection interface.
 */
export function instanceOfSurfaceRulesSection(value: object): value is SurfaceRulesSection {
    return true;
}

export function SurfaceRulesSectionFromJSON(json: any): SurfaceRulesSection {
    return SurfaceRulesSectionFromJSONTyped(json, false);
}

export function SurfaceRulesSectionFromJSONTyped(json: any, ignoreDiscriminator: boolean): SurfaceRulesSection {
    if (json == null) {
        return json;
    }
    return {
        
        'heading': json['heading'] == null ? undefined : json['heading'],
        'paragraphs': json['paragraphs'] == null ? undefined : json['paragraphs'],
    };
}

export function SurfaceRulesSectionToJSON(json: any): SurfaceRulesSection {
    return SurfaceRulesSectionToJSONTyped(json, false);
}

export function SurfaceRulesSectionToJSONTyped(value?: SurfaceRulesSection | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'heading': value['heading'],
        'paragraphs': value['paragraphs'],
    };
}

